/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const SHOW_HEADER = 'SHOW_HEADER'
export const SHOW_PLAN_BUTTON = 'SHOW_PLAN_BUTTON'
export const SHOW_NAVLINKS = 'SHOW_NAVLINKS'
export const SHOW_FOOTER = 'SHOW_FOOTER'
export const SET_FOOTER_COLORS = 'SET_FOOTER_COLORS'

export const showHeader = (show: boolean) => {
  return {
    type: SHOW_HEADER,
    show,
  }
}

export const showPlanButton = (show: boolean) => {
  return {
    type: SHOW_PLAN_BUTTON,
    show,
  }
}

export const showNavlinks = (show: boolean) => {
  return {
    type: SHOW_NAVLINKS,
    show,
  }
}

export const showFooter = (show: boolean) => {
  return {
    type: SHOW_FOOTER,
    show,
  }
}

export const setFooterColors = (primary: string, secondary: string) => {
  return {
    type: SET_FOOTER_COLORS,
    colors: {
      primary,
      secondary,
    },
  }
}
